import React from 'react';
import FilterCountBadge
  from '@components/pages/ShopV3/components/Sidebar/components/FilterCountBadge/FilterCountBadge';
import classNames from 'classnames/bind';
import FilterIcon from '../svg/filter.svg';
import styles from './DesktopFilterToggle.module.scss';

export interface IDesktopFilterToggle {
  onClick: () => void;
  isSidebarExpanded: boolean;
  filterCount: number;
}

const DesktopFilterToggle = ({
  onClick,
  isSidebarExpanded,
  filterCount
}: IDesktopFilterToggle) => {
  return (
    <button
      type="button"
      className={classNames(styles.FilterButton)}
      onClick={() => onClick()}
    >
      <span className={classNames(styles.Text)}>
        {
          isSidebarExpanded ? 'Hide' : 'Filters'
        }
      </span>
      <FilterIcon />
      {
        filterCount > 0 && !isSidebarExpanded && (
          <FilterCountBadge count={filterCount} />
        )
      }
    </button>
  );
};

export default DesktopFilterToggle;
